import { BorderRadiusTokens, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { isMobile } from '../../configs/utils';
import { ACTION } from './types';
import { ROUTE } from '../../routes';
const _isMobile = isMobile();
export const CitySelectionDs = (cityData) => {
    const DS = {
        citySelectionContainer: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            hide: true,
            maxWidth: _isMobile ? '100%' : 400,
            bgColor: ColorTokens.White,
            borderConfig: {
                borderColor: ColorTokens.Primary_10,
                borderRadius: BorderRadiusTokens.BR2,
                borderWidth: {
                    all: SizeTypeTokens.Size1,
                },
            },
            padding: {
                left: SizeTypeTokens.Size32,
                right: SizeTypeTokens.Size32,
                top: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.Size32,
            },
            widgetItems: [
                { id: 'citySelectionIconTopStack', type: WIDGET.STACK },
                // { id: 'citySelectionIconBackI1', type: WIDGET.ICON },
                // { id: 'citySelectionS0', type: WIDGET.SPACE },
                // { id: 'citySelectionT1', type: WIDGET.TEXT },
                { id: 'citySelectionS1', type: WIDGET.SPACE },
                { id: 'citySelection', type: WIDGET.SELECTION_COMPONENT }
            ],
        },
        citySelectionIconTopStack: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'citySelectionIconBackI1', type: WIDGET.ICON },
                { id: 'citySelectionS0', type: WIDGET.SPACE },
                { id: 'citySelectionT1', type: WIDGET.TEXT },
            ]
        },
        citySelectionIconBackI1: {
            name: IconTokens.Back,
            size: IconSizeTokens.XXXL,
            action: {
                type: ACTION.CITY_GO_BACK,
                routeId: ROUTE.PARTNER_SIGNUP,
                payload: {}
            }
        },
        citySelectionT1: {
            label: 'Select city',
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.LG,
            fontWeight: "400",
            lineHeight: 26
        },
        citySelectionS1: {
            size: SizeTypeTokens.XL
        },
        citySelectionS0: {
            size: SizeTypeTokens.XL
        },
        citySelection: {
            // data: [
            //     {
            //         id: 1,
            //         value: 'Bengaluru'
            //     },
            //     {
            //         id: 1,
            //         value: 'Delhi'
            //     },
            //     {
            //         id: 1,
            //         value: 'Mumbai'
            //     },
            //     {
            //         id: 1,
            //         value: 'Indore'
            //     },
            //     {
            //         id: 1,
            //         value: 'Bengaluru'
            //     },
            //     {
            //         id: 1,
            //         value: 'Delhi'
            //     },
            //     {
            //         id: 1,
            //         value: 'Mumbai'
            //     },
            //     {
            //         id: 1,
            //         value: 'Indore'
            //     },
            // ],
            data: cityData && cityData.map((item, index) => {
                return {
                    id: index + 1,
                    value: item
                };
            }),
            searchString: '',
            emptyString: 'No city found.',
            action: {
                routeId: ROUTE.PARTNER_SIGNUP,
                type: ACTION.SELECT_CITY,
                payload: {
                    value: ''
                }
            }
        }
    };
    return DS;
};
